const isTrendUp = (t) =>
  t === "up" || t === "increased" || t === 1 || t === "1";

const isTrendDown = (t) =>
  t === "down" || t === "decreased" || t === 2 || t === "2";

export function desktopOddsBgClass(trend) {
  if (isTrendUp(trend)) return "kbv-cs-bg-odds-up-desktop";
  if (isTrendDown(trend)) return "kbv-cs-bg-odds-down-desktop";
  return "bg-[color:var(--theme-accent)]";
}

export function mobileOddsBgClass(trend) {
  if (isTrendUp(trend)) return "kbv-cs-bg-odds-up-mobile";
  if (isTrendDown(trend)) return "kbv-cs-bg-odds-down-mobile";
  return "bg-[color:var(--theme-accent)]";
}
